import React, { useEffect, useState } from 'react';
import { Button, Col, Collapse, Form, Row, Spin } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useAppSelector } from '../../../store/hooks';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { FieldsSubscriptions } from '../../../lib/interfaces/Subscriptions';
import { AxiosResponse } from 'axios';
import { ReactComponent as ArrowDownFigIcon } from '../../../lib/img/arrow-down-fig.svg';
import { Checkbox } from 'antd/es';
import { uniqueId } from 'lodash';
import { checkIsLoading } from '../../../lib/utils/checkLoadingStatus';
import './UserProfileSubscriptions.less';

interface IProps {
  handleEditSubscriptions: (fields: FieldsSubscriptions) => Promise<AxiosResponse>;
}

const UserProfileSubscriptions = ({ handleEditSubscriptions }: IProps) => {
  const { subscriptions, subscriptionsLoading } = useAppSelector((state) => state.subscriptions);
  const { personCategories, appSubject } = useAppSelector((state) => state.dictionaries);
  const { projects } = useAppSelector((state) => state.projects);
  const { meUserFull } = useAppSelector((state) => state.persons);

  const [subscriptionForm] = useForm();

  const [isUpdateSubscription, setIsUpdateSubscription] = useState(false);

  const [isChangeSubscription, setIsChangeSubscription] = useState(false);

  const findSubscribtion = subscriptions.find((subscription) => subscription.notificationTypeId === 15);

  useEffect(() => {
    const initialValues = {
      projectIds: findSubscribtion?.subscriptionCondition?.projectIds,
      appSubjectIds: findSubscribtion?.subscriptionCondition?.appSubjectIds,
      wardCategoryIds: findSubscribtion?.subscriptionCondition?.wardCategoryIds,
    };
    subscriptionForm.setFieldsValue(initialValues);
    setIsChangeSubscription(false);

    return () => {
      subscriptionForm.setFieldsValue({
        projectIds: findSubscribtion?.subscriptionCondition?.projectIds,
        appSubjectIds: findSubscribtion?.subscriptionCondition?.appSubjectIds,
        wardCategoryIds: findSubscribtion?.subscriptionCondition?.wardCategoryIds,
      });
      setIsChangeSubscription(false);
    };
  }, [subscriptions]);

  const subscriptionsInfo = () => {
    const allAppSubjectIds = appSubject.map((item) => item.id);
    const allWardCategoryIds = personCategories.map((item) => item.id);
    const allProjectsIds = projects
      .filter((project) => project.regionId === meUserFull?.regionId && project.projectTypeId === 1)
      .map((item) => item.id);

    const onFinishSubscriptions = (val) => {
      setIsUpdateSubscription(true);

      handleEditSubscriptions(val).finally(() => {
        setIsUpdateSubscription(false);
        setIsChangeSubscription(false);
      });
    };

    const onCheckAll = (e: CheckboxChangeEvent, listType: 'projectIds' | 'appSubjectIds' | 'wardCategoryIds') => {
      setIsChangeSubscription(true);
      switch (listType) {
        case 'projectIds':
          subscriptionForm.setFieldsValue({
            [listType]: e.target.checked ? allProjectsIds : [],
          });

          break;
        case 'appSubjectIds':
          subscriptionForm.setFieldsValue({
            [listType]: e.target.checked ? allAppSubjectIds : [],
          });

          break;
        case 'wardCategoryIds':
          subscriptionForm.setFieldsValue({
            [listType]: e.target.checked ? allWardCategoryIds : [],
          });

          break;
      }
    };

    const isCheckedAll = (listType: 'projectIds' | 'appSubjectIds' | 'wardCategoryIds', allCheckIds): boolean => {
      switch (listType) {
        case 'projectIds':
          return allProjectsIds.length === allCheckIds?.length;
        case 'appSubjectIds':
          return allAppSubjectIds.length === allCheckIds?.length;
        case 'wardCategoryIds':
          return allWardCategoryIds.length === allCheckIds?.length;
      }
    };

    return (
      <Form form={subscriptionForm} onFinish={onFinishSubscriptions} className="subscription-list-form">
        <Collapse
          defaultActiveKey={['1', '2', '3']}
          ghost
          expandIconPosition="end"
          expandIcon={({ isActive }) => (
            <ArrowDownFigIcon className={`subscription-list-form-arrow ${isActive ? 'rotate' : ''}`} />
          )}
        >
          <Collapse.Panel header="Проект" key="1">
            {Array.isArray(projects) && projects.length > 0 && (
              <>
                <Form.Item
                  shouldUpdate={(prevValues, currentValues) => prevValues?.projectIds !== currentValues?.projectIds}
                  noStyle
                >
                  {({ getFieldValue }) => {
                    return (
                      <div>
                        <Checkbox
                          value={uniqueId()}
                          onChange={(e) => onCheckAll(e, 'projectIds')}
                          className="mr3 subscription-list-checkbox"
                          checked={isCheckedAll('projectIds', getFieldValue('projectIds'))}
                        />
                        <span className="subscription-list-item">Выбрать всё</span>
                      </div>
                    );
                  }}
                </Form.Item>
                <Form.Item name="projectIds" style={{ display: 'flex', justifyContent: 'start', width: '100%' }}>
                  <Checkbox.Group style={{ width: '100%' }}>
                    {projects
                      .filter((project) => project.regionId === meUserFull?.regionId && project.projectTypeId === 1)
                      .map((item) => (
                        <div key={item.id} className="subscription-list-item-container">
                          <Checkbox
                            value={item.id}
                            className="mr3 subscription-list-checkbox"
                            onChange={() => setIsChangeSubscription(true)}
                          />
                          <span className="subscription-list-item">{item.title}</span>
                        </div>
                      ))}
                  </Checkbox.Group>
                </Form.Item>
              </>
            )}
          </Collapse.Panel>
          <Collapse.Panel header="Вид помощи" key="2">
            {Array.isArray(appSubject) && appSubject.length > 0 && (
              <>
                <Form.Item
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues?.appSubjectIds !== currentValues?.appSubjectIds
                  }
                  noStyle
                >
                  {({ getFieldValue }) => {
                    return (
                      <div>
                        <Checkbox
                          value={uniqueId()}
                          onChange={(e) => onCheckAll(e, 'appSubjectIds')}
                          className="mr3 subscription-list-checkbox"
                          checked={isCheckedAll('appSubjectIds', getFieldValue('appSubjectIds'))}
                        />
                        <span className="subscription-list-item">Выбрать всё</span>
                      </div>
                    );
                  }}
                </Form.Item>
                <Form.Item name="appSubjectIds" style={{ display: 'flex', justifyContent: 'start' }}>
                  <Checkbox.Group style={{ width: '100%' }}>
                    {appSubject.map((item) => (
                      <div key={item.id} className="subscription-list-item-container">
                        <Checkbox
                          value={item.id}
                          className="subscription-list-checkbox"
                          onChange={() => setIsChangeSubscription(true)}
                        />
                        <span className="subscription-list-item">{item.name}</span>
                      </div>
                    ))}
                  </Checkbox.Group>
                </Form.Item>
              </>
            )}
          </Collapse.Panel>
          <Collapse.Panel header="Категория" key="3">
            {Array.isArray(personCategories) && personCategories.length > 0 && (
              <>
                <Form.Item
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues?.wardCategoryIds !== currentValues?.wardCategoryIds
                  }
                  noStyle
                >
                  {({ getFieldValue }) => {
                    return (
                      <div>
                        <Checkbox
                          value={uniqueId()}
                          onChange={(e) => onCheckAll(e, 'wardCategoryIds')}
                          className="mr3 subscription-list-checkbox"
                          checked={isCheckedAll('wardCategoryIds', getFieldValue('wardCategoryIds'))}
                        />
                        <span className="subscription-list-item">Выбрать всё</span>
                      </div>
                    );
                  }}
                </Form.Item>
                <Form.Item name="wardCategoryIds" style={{ display: 'flex', justifyContent: 'start' }}>
                  <Checkbox.Group style={{ width: '100%' }}>
                    {personCategories.map((item) => (
                      <div key={item.id} className="subscription-list-item-container">
                        <Checkbox
                          value={item.id}
                          className="subscription-list-checkbox"
                          onChange={() => setIsChangeSubscription(true)}
                        />
                        <span className="subscription-list-item">{item.name}</span>
                      </div>
                    ))}
                  </Checkbox.Group>
                </Form.Item>
              </>
            )}
          </Collapse.Panel>
        </Collapse>
      </Form>
    );
  };

  return (
    <div className="user-profile-subscriptions-container ml20 mr20" style={{ width: '100%' }}>
      <Row className="user-profile-subscriptions">
        <Col span={24} className="user-profile-subscriptions__title">
          <span>
            Выберите интересующие характеристики, <br /> и мы будем оповещать вас о подходящих просьбах
          </span>
        </Col>
        <Spin spinning={isUpdateSubscription || checkIsLoading(subscriptionsLoading)}>
          <div className="user-profile-subscriptions__content">{subscriptionsInfo()}</div>
        </Spin>
      </Row>
      <div className="mt10 display-flex pb10" style={{ alignItems: 'start' }}>
        <Button
          style={{ width: 247 }}
          onClick={() => subscriptionForm.submit()}
          disabled={isUpdateSubscription || checkIsLoading(subscriptionsLoading) || !isChangeSubscription}
        >
          Сохранить изменения
        </Button>
      </div>
    </div>
  );
};

export default UserProfileSubscriptions;
